import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types"
import thLocale from 'date-fns/locale/th'

import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";
import * as budgetsActions from "src/redux/actions/budgets.action";
import * as getprojectActions from "src/redux/actions/getproject.action";
import * as getprojectdetailActions from "src/redux/actions/getprojectdetail.action";
import * as budgetmonthActions from "src/redux/actions/budgetmonth.action";
import * as insertbudgetsActions from "src/redux/actions/insertbudgets.action";
import * as insertprojectActions from "src/redux/actions/insertproject.action";
import * as deleteprojectActions from "src/redux/actions/deleteproject.action";
import * as getbuheadActions from "src/redux/actions/getbuhead.action";
import * as updatebuheadActions from "src/redux/actions/updatebuhead.action";
import * as budgetsdetailActions from "src/redux/actions/budgetsdetail.action";
import * as sendemailbuheadActions from "src/redux/actions/sendemailbuhead.action";
import * as getbudgetfaActions from "src/redux/actions/getbudgetfa.action";
import * as checktokenActions from "src/redux/actions/checktoken.action";
import { useParams } from "react-router-dom";
import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Modal,
  Backdrop,
  Fade,
  Card,
  CardContent,
  MenuItem,
  Paper,
  Box,
  CircularProgress,
  Container,
  CardHeader,
  Divider,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import { Formik, Form, Field } from "formik";
import {
  TimePicker,
  DatePicker,
  DateTimePicker,
} from "formik-material-ui-pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  TextField as TextFieldFormik,
  CheckBox as CheckBoxFormik,
} from "formik-material-ui";
import Moment from "moment";
import { httpClient } from "src/utils/HttpClient";
import { result, isNull, set } from "lodash";
import NumberFormat from "react-number-format";
import budgetsdetailReducer from "src/redux/reducers/budgetsdetail.reducer";
import Page from "src/components/Page";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  formsearch: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "40ch",
    },
  },
  inputEditNumber: {
    width: "10ch",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function Expenses() {
  const classes = useStyles();

  const [value, setValue] = useState(0);
  // const [value1, setValue] = useState('1');
  const [open, setOpen] = useState(false);
  const [openModalApprove, setopenModalApprove] = useState(false);
  const [openinvestment, setOpeninvestment] = useState(false);
  const [openinvestmentedit, setOpeninvestmentedit] = useState(false);
  const [openDlgconfirm, setopenDlgconfirm] = useState(false);
  const [openDlgconfirmBudget, setopenDlgconfirmBudget] = useState(false);
  const [openPopupDlg, setOpenPopupDlg] = useState(false);
  const [openPopupDlgSucc, setOpenPopupDlgSucc] = useState(false);

  const [budgetpId, setbudgetpId] = useState(0);
  // const [budgetsdsid, setBudgetsdsid] = useState(0);
  const [editData, setEditData] = useState({});
  const [brandId, setBrandId] = useState(null);
  const [deptId, setDeptId] = useState(null);
  const [yearId, setYearId] = useState(null);
  const [onSubmit, setOnSubmit] = useState(false);
  const [buheadId, setBuheadId] = useState(0);
  const [buheadEmail, setBuheadEmail] = useState("");
  const [buheadFullname, setbuheadFullname] = useState("");
  const [yearCode, setyearCode] = useState();
  const [yearLock, setYearLock] = useState(null);
  const [checkRecBudget, setCheckRecBudget] = useState(true);
  const [checkRecReport, setCheckRecReport] = useState(true);
  const [checkRefreshdata, setCheckRefreshdata] = useState(true);
  const [checkSwap, setCheckSwap] = useState(0);

  const [yearminDate, setMinDate] = useState("01/01/" + yearCode);
  const [yearmaxDate, setMaxDate] = useState("12/31/" + yearCode);

  const loginReducer = useSelector((state) => state.loginReducer);

  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(({ budgetsReducer }) => budgetsReducer);
  const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector(
    ({ departmentReducer }) => departmentReducer
  );
  const insertbudgetsReducer = useSelector(
    (state) => state.insertbudgetsReducer
  );
  const getprojectReducer = useSelector((state) => state.getprojectReducer);
  const getbuheadReducer = useSelector((state) => state.getbuheadReducer);
  const getfilesReducer = useSelector((state) => state.getfilesReducer);

  const budgetsdetailReducer = useSelector(
    (state) => state.budgetsdetailReducer
  );

  const getbudgetfaReducer = useSelector((state) => state.getbudgetfaReducer);
  

  
  const dispatch = useDispatch();

  useEffect(() => {
    // Get Brand
    dispatch(budgetsActions.clearBudgets());
    dispatch(
      brandActions.getBrands(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid
      )
    );

    return () => {
      dispatch(budgetsActions.clearBudgets());

      dispatch(getprojectActions.getProject(0));
      dispatch(budgetsdetailActions.getBudgetsDetail(0, 0, 0, 0, 0, 0));
      dispatch(
        departmentActions.getDepts(loginReducer.result.countryid, 0, 0, 0)
      );
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid + loginReducer.result.companyid + 0 + 0
        )
      );
    };
  }, []);

  const renderNewProject4PrBtn = () => {
    if (budgetsReducer.isLoading) {
      return (
        <Button
          variant="contained"
          color="default"
          disabled="true"
          startIcon={<Icon>add</Icon>}
        >
          New Project for PR
        </Button>
      );
    }

    return (
      <Button
        variant="contained"
        color="default"
        disabled={controlButtonNewProjectPR()}
        startIcon={<Icon>add</Icon>}
        onClick={(e) => {
          e.preventDefault();
          setOpeninvestment(true);
        }}
      >
        New Project for PR
      </Button>
    );
  };

  const renderNewProjectBtn = () => {
    if (budgetsReducer.isLoading) {
      return (
        <Button
          variant="contained"
          color="default"
          disabled="true"
          startIcon={<Icon>add</Icon>}
        >
          New Project
        </Button>
      );
    }

    return (
      <Button
        variant="contained"
        color="default"
        disabled={controlButtonNewProject()}
        startIcon={<Icon>add</Icon>}
        onClick={(e) => {
          e.preventDefault();
          setOpeninvestment(true);
        }}
      >
        New Project
      </Button>
    );
  };

  const handleCloseModalApprove = () => {
    setopenModalApprove(false);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleCloseModalInvestment = () => {
    setOpeninvestment(false);
  };

  const handleCloseModalInvestmentEdit = () => {
    setOpeninvestmentedit(false);
  };

  const handleOpenModalInvestmentEdit = (data) => {
    setEditData(data);
    setOpeninvestmentedit(true);
  };

  const handleChangeBrand = (e) => {
    const data = e.target.value;
    setBrandId(data);
    clearDataDropDown();
    setYearLock(0);
    setDeptId(null);
    setOnSubmit(false);
    dispatch(
      departmentActions.getDepts(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid,
        data
      )
    );
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid + loginReducer.result.companyid + 0 + 0
      )
    );
    setCheckRecBudget(true);
    setCheckRecReport(true);
    // setcheckRecSubmit(true);
  };

  const handleChangeDepartment = (e) => {
    const data = e.target.value;
    setDeptId(data);
    clearDataDropDown();
    setYearLock(0);
    setYearId(null);
    setOnSubmit(false);
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid +
          loginReducer.result.companyid +
          brandId +
          data
      )
    );

    setCheckRecBudget(true);
    setCheckRecReport(true);
    // setcheckRecSubmit(true);
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);

    clearDataDropDown();
    setYearId(BUDGETH_ID);
    setyearCode(YEAR_CODE);
    setYearLock(BUDGETH_LOCK);
    setMinDate("01/01/" + YEAR_CODE);
    setMaxDate("12/31/" + YEAR_CODE);

    setOnSubmit(false);
    setCheckRecBudget(true);
    setCheckRecReport(true);
    // setcheckRecSubmit(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const showModalinvest = ({values,setFieldValue}) => {
    return (
      <Form>
        <Typography gutterBottom variant="h5">
          {/* <Icon>edit</Icon> */}
          Project information
        </Typography>
        {/* <br /> */}
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={1}>
              {/* <> */}
              <Grid item xs={8}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BTYPE"
                  // type="number"
                  defaultValue={"1"}
                  label="Project Type"
                  // autoFocus
                  required
                  select
                >
                  <MenuItem value={1}>New Store </MenuItem>
                  <MenuItem value={2}>Renovation </MenuItem>
                  <MenuItem value={3}>Relocation </MenuItem>
                  <MenuItem value={4}>Investment at HO </MenuItem>
                </Field>
              </Grid>
              {/* </> */}
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BNAME"
                  // type="number"
                  // defaultValue={item.V_BUDGETSD_M2}
                  label="Project Name"
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BLOCATION"
                  type="text"
                  // defaultValue={item.V_BUDGETSD_M3}
                  label="Locations"
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BSQM"
                  type="number"
                  // value="-"
                  // defaultValue={value ? "-" : "-"}
                  label="Size / Sqm."
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="AREA"
                  type="number"
                  defaultValue={"1"}
                  label="Area Type"
                  select
                  required
                >
                  <MenuItem value={"1"}>Bangkok </MenuItem>
                  <MenuItem value={"2"}>Upcountry </MenuItem>
                </Field>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                  <Field
                      className={classes.field}
                      fullWidth
                      component={DatePicker}
                      values={values.OPENDATE}
                      onChange={value => {
                        setFieldValue("OPENDATE", Moment(value).format("MM/DD/yyyy"))
                      }}
                      name="OPENDATE"
                      format="dd/MM/yyyy"
                      minDate={new Date(yearminDate)}
                      maxDate={new Date(yearmaxDate)}
                      label="Expected Open Date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      required
                    />

              </Grid>
              <Grid item xs={6}>
                  <Field
                      className={classes.field}
                      fullWidth
                      component={DatePicker}
                      values={values.CLOSEDATE}
                      onChange={value => {
                        setFieldValue("CLOSEDATE", Moment(value).format("MM/DD/yyyy"))
                      }}
                      name="CLOSEDATE"
                      format="dd/MM/yyyy"
                      minDate={new Date(yearminDate)}
                      maxDate={new Date(yearmaxDate)}
                      label="Expected Close Date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      required
                    />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="REMARK"
                  // type="number"
                  // defaultValue={item.V_BUDGETSD_M8}
                  label="Remark"
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>
            <br />
            {/* <div style={{ marginTop: 20 }}>{showPreviewImage(values)}</div> */}
          </CardContent>
          {/* <CardActions> */}
          <Grid container spacing={1}>
            <Grid item xs={4}></Grid>
            <Grid item xs={8}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                alignItems="end"
                // disabled={!(isValid && dirty)}
              >
                Save Project
              </Button>
              <Button
                // component={Link}
                onClick={handleCloseModalInvestment}
                color="default"
                raised
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
          <br />
          {/* </CardActions> */}
        </Card>
      </Form>
    
    
    );
  };

  const showModalinvestEdit = ({values,setFieldValue}) => {
    return (
      <Form>
        <Typography gutterBottom variant="h5">
          {/* <Icon>edit</Icon> */}
          Edit Project information
        </Typography>
        {/* <br /> */}
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={1}>
              {/* <> */}
              <Grid item xs={8}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BUDGETP_TYPE"
                  // type="number"
                  // defaultValue={"1"}
                  label="Project Type"
                  // autoFocus
                  required
                  select
                >
                  <MenuItem value={1}>New Store </MenuItem>
                  <MenuItem value={2}>Renovation </MenuItem>
                  <MenuItem value={3}>Relocation </MenuItem>
                  <MenuItem value={4}>Investment at HO </MenuItem>
                </Field>
              </Grid>
              {/* </> */}
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BUDGETP_NAME"
                  // type="number"
                  // defaultValue={item.V_BUDGETSD_M2}
                  label="Project Name"
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BUDGETP_LOCATION"
                  type="text"
                  // defaultValue={item.V_BUDGETSD_M3}
                  label="Locations"
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BUDGETP_SQM"
                  type="number"
                  // defaultValue={0}
                  label="Size (Sqm.)"
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BUDGETP_AREA"
                  type="number"
                  defaultValue={"1"}
                  label="Area Type"
                  select
                  required
                >
                  <MenuItem value={"1"}>Bangkok </MenuItem>
                  <MenuItem value={"2"}>Upcountry </MenuItem>
                </Field>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={DatePicker}
                  name="BUDGETP_OPENDATE"
                  format="dd/MM/yyyy"
                  onChange={value => {
                    setFieldValue("BUDGETP_OPENDATE", Moment(value).format("MM/DD/yyyy"))
                  }}
                  minDate={new Date(yearminDate)}
                  maxDate={new Date(yearmaxDate)}
                  // defaultValue={item.V_BUDGETSD_M6}
                  label="Expected Open Date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // defaultValue={Date()}
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={DatePicker}
                  name="BUDGETP_CLOSEDATE"
                  onChange={value => {
                    setFieldValue("BUDGETP_CLOSEDATE", Moment(value).format("MM/DD/yyyy"))
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  format="dd/MM/yyyy"
                  minDate={new Date(yearminDate)}
                  maxDate={new Date(yearmaxDate)}
                  label="Expected Close Date"
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Field
                  className={classes.field}
                  fullWidth
                  component={TextFieldFormik}
                  name="BUDGETP_REMARK"
                  // type="number"
                  // defaultValue={item.V_BUDGETSD_M8}
                  label="Remark"
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>
            <br />
            {/* <div style={{ marginTop: 20 }}>{showPreviewImage(values)}</div> */}
          </CardContent>
          {/* <CardActions> */}
          <Grid container spacing={1}>
            <Grid item xs={4}></Grid>
            <Grid item xs={8}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                alignItems="end"
                // disabled={!(isValid && dirty)}
              >
                Update Project
              </Button>
              <Button
                // component={Link}
                onClick={handleCloseModalInvestmentEdit}
                color="default"
                raised
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
          <br />
          {/* </CardActions> */}
        </Card>
      </Form>
    );
  };

  const showModalApprove = ({ values }) => {
    return (
      <form
        style={{ width: 500 }}
        onSubmit={(e) => {
          let databuhead = {
            BUHEAD_MEMID: buheadId,
            MEMIDX: loginReducer.result.perid,
          };
          dispatch(
            updatebuheadActions.updateBuheadById(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearId,
              databuhead
            )
          );
          let datamail = {
            BUEMAIL: buheadEmail,
            FULLNAMEPER: loginReducer.result.fullname,
          };

          // send mail
          dispatch(sendemailbuheadActions.sendEmailBuhead(datamail));
          setOpenPopupDlgSucc(true);
        }}
      >
        <Typography gutterBottom variant="h5">
          Save to Approve
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={1}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                select
                onChange={handleChangeBuhead}
                id="per_id"
                label="Submit To "
                autoFocus
                style={{ width: "100%" }}
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                defaultValue="None"
              >
                <option key={0} value="" selected>
                  -
                </option>
                {getbuheadReducer.result &&
                  getbuheadReducer.result.map((item) => (
                    <option key={item.PER_ID} value={JSON.stringify(item)}>
                      {/* <option key={item.PER_ID} value={item.PER_ID}> */}
                      {item.FULLNAME}
                    </option>
                  ))}
              </TextField>
            </Grid>
            <br />
            <Grid container spacing={1}>
              <Field type="checkbox" name="acceptTerms" required />{" "}
              <Typography style={{ color: "red" }}>
                Data cannot be changed after submission{" "}
                <Typography style={{ color: "black" }}>
                  {" "}
                  Confirm to submit ?
                </Typography>
              </Typography>
            </Grid>
          </CardContent>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="space-between"
                m={1}
                p={1}
                flexWrap="wrap"
              >
                <Box p={1} display="flex" flexDirection="row">
                  <Box mr={5}>
                    <Button variant="contained" color="primary" type="submit">
                      Submit
                    </Button>
                  </Box>
                  <Box mr={5}>
                    <Button
                      // component={Link}
                      onClick={handleCloseModalApprove}
                      color="default"
                      raised
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <br />
          {/* </CardActions> */}
        </Card>
      </form>
    );
  };
  const handleChangeBuhead = (e) => {
    const { PER_ID, FULLNAME, PER_EMAIL } = JSON.parse(e.target.value);
    // const data = e.target.value;

    setBuheadId(PER_ID);
    setbuheadFullname(FULLNAME);
    setBuheadEmail(PER_EMAIL);
  };
  const handleConfirmDlg = (value) => {
    if (value) {
      // setTimeout(() => {
      dispatch(deleteprojectActions.deleteProjectById(budgetpId));
      // }, 1000),
      setTimeout(() => {
        dispatch(getprojectActions.getProject(budgetsReducer.sid));
      }, 1000);
    }
    setopenDlgconfirm(false);
  };
  const handleConfirmDlgBudget = (value) => {
    if (value) {
      // e.preventDefault();
      let data = {
        YEARID: yearId,
        COUNTRYID: loginReducer.result.countryid,
        COMPANYID: loginReducer.result.companyid,
        BRANDID: brandId,
        DEPARTID: deptId,
        MEMID: loginReducer.result.perid,
        SECID: loginReducer.result.secureid,
      };

      dispatch(insertbudgetsActions.insertBudgetsById(data));

      setopenDlgconfirmBudget(false);
    } else {
      setopenDlgconfirmBudget(false);
    }
  };
  const handlePopupDlg = (value) => {
    if (value) {
      setOpenPopupDlg(false);
    }
  };
  const handlePopupDlgSucc = (value) => {
    if (value) {
      setOpenPopupDlgSucc(false);
    }
  };

  const clearDataDropDown = (e) => {
    dispatch(getprojectActions.clearProject());
    dispatch(budgetsActions.clearBudgets());
    dispatch(budgetsdetailActions.clearBudgetsDetail());
  };

  const checkEditExpense = (rowData) => {
    if (yearLock === 0) {
      if (budgetsReducer.actid === 0) {
        if (rowData.ACC_TYPE === 1 || rowData.ACC_TYPE === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const checkEditInve = (rowData) => {
    if (yearLock === 0) {
      if (budgetsReducer.actid === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const checkButtonSubmit = () => {
    const result = budgetsReducer.actid + yearLock;
    if (result >= 1) {
      return true;
    } else {
      return false;
    }
  };
  const checkButtonSubmitPr = () => {
    const result = budgetsReducer.actid + yearLock;
    if (result >= 2) {
      return false;
    } else {
      return true;
    }
  };

  const controlButtonLoadbudget = () => {
    if (
      brandId !== null &&
      deptId !== null &&
      yearId !== null &&
      onSubmit &&
      !checkButtonSubmit()
    ) {
      return false;
    }
    return true;
  };

  const controlButtonNewProjectPR = () => {
    if (
      budgetsReducer.sid > 0 &&
      brandId !== null &&
      deptId !== null &&
      yearId !== null &&
      onSubmit &&
      !checkButtonSubmitPr()
    ) {
      return false;
    }
    return true;
  };

  const controlButtonNewProject = () => {
    if (
      budgetsReducer.sid > 0 &&
      brandId !== null &&
      deptId !== null &&
      yearId !== null &&
      onSubmit &&
      !checkButtonSubmit()
    ) {
      return false;
    }
    return true;
  };

  const renderButtonSubmit = () => {
    if (budgetsReducer.result.length > 0) {
      return (
        <Button
          variant="contained"
          color="primary"
          disabled={checkButtonSubmit()}
          onClick={(e) => {
            e.preventDefault();
            dispatch(getbuheadActions.getBuHead(loginReducer.result.perid));
            setopenModalApprove(true);
          }}
          startIcon={<Icon>check</Icon>}
        >
          Submit
        </Button>
      );
    }
    return;
  };

  const renderButtonLoadBudget = () => {
    if (!budgetsReducer.isFetching) {
      return (
        <Button
          variant="contained"
          color="default"
          startIcon={<Icon>add</Icon>}
          disabled={controlButtonLoadbudget()}
          onClick={(e) => {
            setopenDlgconfirmBudget(true);
          }}
        >
          Load Budget
        </Button>
      );
    }
    return <CircularProgress />;
  };

  const tableRefDetail = React.createRef();

  return (
    // <Alert icon={false} variant="outlined" severity="info">
    //   <Box display="flex" justifyContent="space-between" flexWrap="wrap">
    //     <Box display="flex" flexDirection="row">
    //       <Box mr={2}>
    //         {" "}
    //         <Typography variant="h4">Budget Request</Typography>
    //       </Box>
    //     </Box>
    //     <Box display="flex" flexDirection="row">
    //       <Box mr={2}>
    //         {" "}
    //         {yearLock === 1 ? (
    //           <Alert icon={false} severity="warning">
    //             <Typography variant="button" display="block">
    //               Year Locked
    //             </Typography>
    //           </Alert>
    //         ) : (
    //           ""
    //         )}
    //       </Box>
    //       <Box mr={2}>
    //         {" "}
    //         {budgetsReducer.actid + budgetsReducer.appid > 1 ? (
    //           <Alert icon={false} severity="success">
    //             <Typography variant="button" display="block">
    //               Approved.
    //             </Typography>
    //           </Alert>
    //         ) : budgetsReducer.actid === 1 ? (
    //           <Alert icon={false} severity="warning">
    //             <Typography variant="button" display="block">
    //               Waiting for approve.
    //             </Typography>
    //           </Alert>
    //         ) : (
    //           ""
    //         )}
    //       </Box>
    //     </Box>
    //   </Box>
    // </Alert>

    <Page className={classes.root} title="Budget Request">
      <Container maxWidth={false}>
        <Card>
          <CardHeader subheader="For request budget" title="Budget Request" />
          {yearLock === 1 ? (
            <Alert icon={false} severity="warning">
              <Typography variant="button" display="block">
                Year Locked
              </Typography>
            </Alert>
          ) : (
            ""
          )}
          {budgetsReducer.actid + budgetsReducer.appid > 1 ? (
            <Alert icon={false} severity="success">
              <Typography variant="button" display="block">
                Approved.
              </Typography>
            </Alert>
          ) : budgetsReducer.actid === 1 ? (
            <Alert icon={false} severity="warning">
              <Typography variant="button" display="block">
                Waiting for approve.
              </Typography>
            </Alert>
          ) : (
            ""
          )}
          <Divider />
          <CardContent>
            <br />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                // setCheckRecBudget(false);
                setCheckRecReport(false);
                setOnSubmit(true);
                // setcheckRecSubmit(false);
                dispatch(
                  budgetsActions.getBudgetsById(
                    loginReducer.result.countryid,
                    loginReducer.result.companyid,
                    brandId,
                    deptId,
                    yearId,
                    loginReducer.result.secureid
                  )
                )
                  .then((result) => {
                    setTimeout(() => {
                      if (result) {
                        // setCheckRecBudget(true);
                        setCheckRecReport(false);
                        setCheckRefreshdata(false);
                        // setcheckRecSubmit(false);
                      } else {
                        // setCheckRecBudget(false);
                        setCheckRecReport(true);
                        setCheckRefreshdata(true);
                        // setcheckRecSubmit(true);
                      }
                    }, 1000);
                    dispatch(getprojectActions.getProject(result));
                    dispatch(
                      budgetsdetailActions.getBudgetsDetail(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        loginReducer.result.secureid
                      )
                    );
                  })
                  .catch((result) => {});
              }}
            >
              <Grid container xs={12}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  flex={1}
                  style={{ lineHeight: 4, justifyContent: "space-between" }}
                >
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeBrand}
                    id="brand"
                    label="Brand"
                    autoComplete="investmenttype"
                    autoFocus
                    style={{ width: "20%", minWidth: "10%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue=""
                  >
                    <option key={0} value="" selected>
                      -
                    </option>
                    {brandReducer.result &&
                      brandReducer.result.map((item) => (
                        <option
                          key={item.ORG_BRAND_ID}
                          value={item.ORG_BRAND_ID}
                        >
                          {item.BRAND}
                        </option>
                      ))}
                  </TextField>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    style={{ width: "50%" }}
                    // value={deptId}
                    onChange={handleChangeDepartment}
                    label="Department"
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue=""
                  >
                    <option key={0} value="" selected>
                      -
                    </option>
                    {departmentReducer.result &&
                      departmentReducer.result.map((item) => (
                        <option
                          key={item.ORG_DEPARTMENT_ID}
                          value={item.ORG_DEPARTMENT_ID}
                        >
                          {item.department}
                        </option>
                      ))}
                  </TextField>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeYear}
                    label="Year"
                    style={{ width: "10%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue=""
                  >
                    <option key={0} value="" selected>
                      -
                    </option>
                    {yearReducer.result &&
                      yearReducer.result.map((item) => (
                        // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                        <option
                          key={item.YEAR_CODE}
                          value={JSON.stringify(item)}
                        >
                          {item.YEAR_SEQ_T}
                        </option>
                      ))}
                  </TextField>
                  <Box>
                    <Button variant="contained" color="default" type="submit">
                      <Icon>search</Icon>Search
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </form>
            <br />
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexWrap="wrap"
                >
                  <Box display="flex" flexDirection="row">
                    <Box mr={5}>{renderButtonLoadBudget()}</Box>
                    <Box mr={5}>{renderButtonSubmit()}</Box>
                  </Box>
                  {/* <Box display="flex" flexDirection="row">
              <Box>
                <Button
                  variant="contained"
                  color="default"
                  // disabled={checkRecBudget}
                  startIcon={<Icon>refresh</Icon>}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(
                      budgetsActions.getBudgetsById(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        loginReducer.result.secureid
                      )
                    )
                      .then((result) => {
                        setTimeout(() => {
                          if (result) {
                            // setCheckRecBudget(true);
                            setCheckRecReport(false);
                            // setcheckRecSubmit(false);
                          } else {
                            // setCheckRecBudget(false);
                            setCheckRecReport(true);
                            // setcheckRecSubmit(true);
                          }
                        }, 1000);
                        dispatch(getprojectActions.getProject(result));
                        dispatch(
                          budgetsdetailActions.getBudgetsDetail(
                            loginReducer.result.countryid,
                            loginReducer.result.companyid,
                            brandId,
                            deptId,
                            yearId,
                            loginReducer.result.secureid
                          )
                        );
                      })
                      .catch((result) => {
                        // Error Message
                      });
                  }}
                >
                  Refresh data
                </Button>
              </Box>
            </Box> */}
                </Box>
              </Grid>
            </Grid>
            <br />

            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="fullWidth"
                centered
              >
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Expenses"
                  onClick={() => {
                    dispatch(
                      budgetsActions.getBudgetsById(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        loginReducer.result.secureid
                      )
                    );
                  }}
                  {...a11yProps(0)}
                />
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Investment"
                  onclick={() => {
                    // setTimeout(() => {
                    dispatch(getprojectActions.getProject(budgetsReducer.sid));
                    // }, 1000);
                  }}
                  {...a11yProps(1)}
                />
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Detail"
                  onClick={() => {
                    // setTimeout(() => {
                    dispatch(
                      budgetsdetailActions.getBudgetsDetail(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        loginReducer.result.secureid
                      )
                    );
                    // }, 1000);
                  }}
                  {...a11yProps(2)}
                />
              </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}>
              {/* Expenses Tab */}
              <Grid container spacing={2}>
                <Paper className={classes.root}>
                  <MaterialTable
                    title="Expenses"
                    isLoading={
                      budgetsReducer.isFetching ||
                      insertbudgetsReducer.isFetching
                    }
                    on
                    columns={[
                      { title: "Group", field: "ACC_GROUP2", width: 100 },
                      { title: "Code", field: "ACC_CODE" },
                      { title: "Name", field: "ACC_NAME" },
                      {
                        title: "Detail",
                        field: "ACCDETAIL",
                        // cellStyle: {
                        //   whiteSpace: "nowrap",
                        // },
                      },
                      {
                        title: "Type",
                        field: "ACC_TYPE_NM",
                      },
                      {
                        title: "Total Budget",
                        field: "BUDGET_TOTAL",
                        width: 150,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGET_TOTAL) {
                            return rowData.BUDGET_TOTAL.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                    ]}
                    data={budgetsReducer.result ? budgetsReducer.result : []}
                    detailPanel={(rowData) => {
                      return (
                        <MaterialTable
                          title={" "}
                          tableRef={tableRefDetail}
                          editable={{
                            // ----
                            isEditable: (rowData) => checkEditExpense(rowData),

                            onRowUpdate: (newData, oldData) =>
                              new Promise((resolve, reject) => {
                                const {
                                  BUDGETSD_SID,
                                  BUDGETSD_ACCID,
                                } = newData;
                                setTimeout(() => {
                                  dispatch(
                                    budgetmonthActions.updateBudgetmonthById(
                                      BUDGETSD_SID,
                                      BUDGETSD_ACCID,
                                      newData
                                    )
                                  );
                                }, 1000);
                                setTimeout(() => {
                                  dispatch(
                                    budgetsActions.getBudgetsById(
                                      loginReducer.result.countryid,
                                      loginReducer.result.companyid,
                                      brandId,
                                      deptId,
                                      yearId,
                                      loginReducer.result.secureid
                                    )
                                  );
                                }, 1000);
                                dispatch(
                                  budgetsdetailActions.getBudgetsDetail(
                                    loginReducer.result.countryid,
                                    loginReducer.result.companyid,
                                    brandId,
                                    deptId,
                                    yearId,
                                    loginReducer.result.secureid
                                  )
                                );
                                // setCheckSwap(1);
                                resolve(newData);
                              }),
                          }}
                          options={{
                            paging: false,
                            search: false,
                            headerStyle: {
                              backgroundColor: "#42ff87",
                            },
                            rowStyle: {
                              backgroundColor: "#c7ffdb",
                            },
                          }}
                          columns={[
                            {
                              title: "Total.",
                              editable: "never",
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData) {
                                  return (
                                    rowData.V_BUDGETSD_M1 +
                                    rowData.V_BUDGETSD_M2 +
                                    rowData.V_BUDGETSD_M3 +
                                    rowData.V_BUDGETSD_M4 +
                                    rowData.V_BUDGETSD_M5 +
                                    rowData.V_BUDGETSD_M6 +
                                    rowData.V_BUDGETSD_M7 +
                                    rowData.V_BUDGETSD_M8 +
                                    rowData.V_BUDGETSD_M9 +
                                    rowData.V_BUDGETSD_M10 +
                                    rowData.V_BUDGETSD_M11 +
                                    rowData.V_BUDGETSD_M12
                                  )
                                    .toFixed(2)
                                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                            },
                            {
                              title: "Jan.",
                              field: "V_BUDGETSD_M1",
                              // field: "YEAR_M1",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M1 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M1) {
                                  return rowData.V_BUDGETSD_M1.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Feb.",
                              field: "V_BUDGETSD_M2",
                              editable: (_, rowData) =>
                               rowData && rowData.YEAR_M2 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M2) {
                                  return rowData.V_BUDGETSD_M2.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Mar.",
                              field: "V_BUDGETSD_M3",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M3 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M3) {
                                  return rowData.V_BUDGETSD_M3.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Apr.",
                              field: "V_BUDGETSD_M4",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M4 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M4) {
                                  return rowData.V_BUDGETSD_M4.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "May",
                              field: "V_BUDGETSD_M5",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M5 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M5) {
                                  return rowData.V_BUDGETSD_M5.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Jun.",
                              field: "V_BUDGETSD_M6",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M6 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M6) {
                                  return rowData.V_BUDGETSD_M6.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Jul.",
                              field: "V_BUDGETSD_M7",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M7 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M7) {
                                  return rowData.V_BUDGETSD_M7.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Aug.",
                              field: "V_BUDGETSD_M8",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M8 === 0,                              
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M8) {
                                  return rowData.V_BUDGETSD_M8.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Sep.",
                              field: "V_BUDGETSD_M9",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M9 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M9) {
                                  return rowData.V_BUDGETSD_M9.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Oct.",
                              field: "V_BUDGETSD_M10",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M10 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M10) {
                                  return rowData.V_BUDGETSD_M10.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Nov.",
                              field: "V_BUDGETSD_M11",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M11 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M11) {
                                  return rowData.V_BUDGETSD_M11.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Dec.",
                              field: "V_BUDGETSD_M12",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M12 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.V_BUDGETSD_M12) {
                                  return rowData.V_BUDGETSD_M12.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                          ]}
                          data={() =>
                            new Promise((resolve, reject) => {
                              setTimeout(() => {
                                httpClient
                                  .get(
                                    `/budget/expense/budgetmonth/${rowData.BUDGETSD_SID}/${rowData.BUDGETSD_ACCID}`
                                  )
                                  .then((result) => {
                                    resolve({
                                      data: result.data,
                                    });
                                  });
                              }, 1000);
                            })
                          }
                        />
                      );
                    }}
                    options={{
                      detailPanelType: "single",
                      exportButton: true,
                      // exportCsv: true,
                      exportAllData: true,
                      toolbarButtonAlignment: "left",
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      searchFieldAlignment: "left",
                      pageSize: 5,
                      pageSizeOptions: [5, 10, 50, 100],
                      paging: true,
                    }}
                  />
                </Paper>
              </Grid>
            </TabPanel>

            <TabPanel value={value} index={1}>
              {/* Investment Tab */}

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    flexWrap="wrap"
                  >
                    <Box display="flex" flexDirection="row">
                      <Box mr={5}>{renderNewProjectBtn()}</Box>
                      <Box mr={5}>
                        {yearLock >= 1 && budgetsReducer.sid != 0
                          ? renderNewProject4PrBtn()
                          : ""}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MaterialTable
                    title="Investment"
                    on
                    isLoading={getprojectReducer.isFetching}
                    columns={[
                      { title: "Type", field: "BUDGETP_TYPE_NM" },
                      { title: "Code.", field: "BUDGETP_CODE" },
                      { title: "Name", field: "BUDGETP_NAME" },
                      {
                        title: "Location",
                        field: "BUDGETP_LOCATION",
                        width: 200,
                      },
                      { title: "Area", field: "BUDGETP_AREA_NM" },
                      {
                        title: "Size (Sqm)",
                        field: "BUDGETP_SQM",
                        render: (rowData) => {
                          if (rowData.BUDGETP_SQM) {
                            return rowData.BUDGETP_SQM.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Total Project",
                        field: "TOTAL_PROJECT",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.TOTAL_PROJECT) {
                            return rowData.TOTAL_PROJECT.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                    ]}
                    data={
                      getprojectReducer.result ? getprojectReducer.result : []
                    }
                    actions={[
                      (rowData) => ({
                        disabled: checkButtonSubmit(),
                        icon: "edit",
                        tooltip: "Edit Project",
                        onClick: (e, rowData) => (
                          <>
                            {
                              (e.preventDefault(),
                              handleOpenModalInvestmentEdit(rowData))
                            }
                          </>
                        ),
                      }),
                      (rowData) => ({
                        disabled: checkButtonSubmit(),
                        icon: "delete",
                        tooltip: "Delete Project",
                        onClick: (e, rowData) => (
                          setbudgetpId(rowData.BUDGETP_ID),
                          // e.preventDefault(),
                          setopenDlgconfirm(true)
                        ),
                      }),
                    ]}
                    options={{
                      detailPanelType: "single",
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      pageSize: 5,
                      pageSizeOptions: [5, 10, 50, 100],
                      paging: true,
                      showTitle: false,
                      search: false,

                      exportButton: true,
                      toolbarButtonAlignment: "left",
                      exportAllData: true,
                    }}
                    detailPanel={(rowData) => {
                      return (
                        <MaterialTable
                          title={"Investment Detail"}
                          tableRef={tableRefDetail}
                          columns={[
                            {
                              title: "Code",
                              field: "ACC_CODE",
                              editable: "never",
                            },

                            {
                              title: "Name",
                              field: "ACC_NAME",
                              editable: "never",
                            },
                            {
                              title: "Total.",
                              editable: "never",
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData) {
                                  return (
                                    rowData.BUDGETSD_M1 +
                                    rowData.BUDGETSD_M2 +
                                    rowData.BUDGETSD_M3 +
                                    rowData.BUDGETSD_M4 +
                                    rowData.BUDGETSD_M5 +
                                    rowData.BUDGETSD_M6 +
                                    rowData.BUDGETSD_M7 +
                                    rowData.BUDGETSD_M8 +
                                    rowData.BUDGETSD_M9 +
                                    rowData.BUDGETSD_M10 +
                                    rowData.BUDGETSD_M11 +
                                    rowData.BUDGETSD_M12
                                  )
                                    .toFixed(2)
                                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                            },
                            {
                              title: "Jan.",
                              field: "BUDGETSD_M1",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M1 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M1) {
                                  return rowData.BUDGETSD_M1.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Feb.",
                              field: "BUDGETSD_M2",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M2 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M2) {
                                  return rowData.BUDGETSD_M2.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Mar.",
                              field: "BUDGETSD_M3",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M3 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M3) {
                                  return rowData.BUDGETSD_M3.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Apr.",
                              field: "BUDGETSD_M4",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M4 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M4) {
                                  return rowData.BUDGETSD_M4.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "May",
                              field: "BUDGETSD_M5",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M5 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M5) {
                                  return rowData.BUDGETSD_M5.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Jun.",
                              field: "BUDGETSD_M6",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M6 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M6) {
                                  return rowData.BUDGETSD_M6.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Jul.",
                              field: "BUDGETSD_M7",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M7 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M7) {
                                  return rowData.BUDGETSD_M7.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Aug.",
                              field: "BUDGETSD_M8",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M8 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M8) {
                                  return rowData.BUDGETSD_M8.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Sep.",
                              field: "BUDGETSD_M9",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M9 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M9) {
                                  return rowData.BUDGETSD_M9.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1,"
                                  );
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Oct.",
                              field: "BUDGETSD_M10",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M10 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M10) {
                                  return rowData.BUDGETSD_M10.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Nov.",
                              field: "BUDGETSD_M11",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M11 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M11) {
                                  return rowData.BUDGETSD_M11.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Dec.",
                              field: "BUDGETSD_M12",
                              editable: (_, rowData) =>
                              rowData && rowData.YEAR_M12 === 0,
                              type: "numeric",
                              render: (rowData) => {
                                if (rowData.BUDGETSD_M12) {
                                  return rowData.BUDGETSD_M12.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                } else {
                                  return "0.00";
                                }
                              },
                              editComponent: (props) => (
                                <TextField
                                  className={classes.inputEditNumber}
                                  // label="react-number-format"
                                  value={props.value}
                                  onChange={(e) =>
                                    props.onChange(
                                      e.target.value ? e.target.value : 0
                                    )
                                  }
                                  name="numberformat"
                                  id="formatted-numberformat-input"
                                  InputProps={{
                                    inputComponent: NumberFormatCustom,
                                  }}
                                />
                              ),
                            },
                            {
                              title: "Detail",
                              field: "ACCDETAIL",
                              editable: "never",
                              cellStyle: {
                                whiteSpace: "nowrap",
                              },
                            },
                          ]}
                          data={(query) =>
                            new Promise((resolve, reject) => {
                              setTimeout(() => {
                                httpClient
                                  .get(
                                    "/budget/investment/project-detail/" +
                                      rowData.BUDGETP_ID,
                                    {
                                      headers: {
                                        authorization: `Bearer ${localStorage.getItem(
                                          "token"
                                        )}`,
                                      },
                                    }
                                  )
                                  .then((result) => {
                                    resolve({
                                      data: result.data.filter(function (obj) {
                                        return Object.keys(obj).some(function (
                                          key
                                        ) {
                                          return obj[key]
                                            ? obj[key]
                                                .toString()
                                                .toLowerCase()
                                                .includes(
                                                  query.search.toLowerCase()
                                                )
                                            : false;
                                        });
                                      }),
                                    });
                                  });
                              }, 1500);
                            })
                          }
                          editable={{
                            isEditable: (rowData) => checkEditInve(rowData),
                            onRowUpdate: (newData, oldData) =>
                              new Promise((resolve, reject) => {
                                const { BUDGETSD_ID } = newData;
                                dispatch(
                                  getprojectdetailActions.updateProjectDetailById(
                                    BUDGETSD_ID,
                                    newData
                                  )
                                );
                                setTimeout(() => {
                                  dispatch(
                                    getprojectActions.getProject(
                                      budgetsReducer.sid
                                    )
                                  );
                                }, 1000);
                                resolve(newData);
                              }),
                            // onRowDelete: (oldData) =>
                            //   new Promise((resolve, reject) => {}),
                          }}
                          options={{
                            showTitle: false,
                            searchFieldAlignment: "left",
                            exportButton: true,
                            toolbarButtonAlignment: "left",
                            exportAllData: true,
                            headerStyle: {
                              backgroundColor: "#42ff87",
                            },
                            rowStyle: {
                              backgroundColor: "#c7ffdb",
                            },

                            paging: false,
                          }}
                        />
                      );
                    }}
                  />
                </Grid>
              </Grid>
              <br />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MaterialTable
                    title="Budget Detail"
                    on
                    isLoading={budgetsdetailReducer.isFetching}
                    columns={[
                      { title: "Type.", field: "ACC_CAT" },
                      { title: "Project Code", field: "PROJECT_CODE" },
                      { title: "Group.", field: "ACC_GROUP2" },
                      { title: "Code.", field: "ACC_CODE" },
                      { title: "Name", field: "ACC_NAME" },
                      { title: "Type", field: "ACC_TYPE_NM" },
                      {
                        title: "Total Budget",
                        field: "TOTAL_BUDGET",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.TOTAL_BUDGET) {
                            return rowData.TOTAL_BUDGET.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jan.",
                        field: "V_BUDGETSD_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M1) {
                            return rowData.V_BUDGETSD_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Feb.",
                        field: "V_BUDGETSD_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M2) {
                            return rowData.V_BUDGETSD_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Mar.",
                        field: "V_BUDGETSD_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M3) {
                            return rowData.V_BUDGETSD_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Apr.",
                        field: "V_BUDGETSD_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M4) {
                            return rowData.V_BUDGETSD_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "May",
                        field: "V_BUDGETSD_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M5) {
                            return rowData.V_BUDGETSD_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jun.",
                        field: "V_BUDGETSD_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M6) {
                            return rowData.V_BUDGETSD_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jul.",
                        field: "V_BUDGETSD_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M7) {
                            return rowData.V_BUDGETSD_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Aug.",
                        field: "V_BUDGETSD_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M8) {
                            return rowData.V_BUDGETSD_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Sep.",
                        field: "V_BUDGETSD_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M9) {
                            return rowData.V_BUDGETSD_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Oct.",
                        field: "V_BUDGETSD_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M10) {
                            return rowData.V_BUDGETSD_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Nov.",
                        field: "V_BUDGETSD_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M11) {
                            return rowData.V_BUDGETSD_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Dec.",
                        field: "V_BUDGETSD_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M12) {
                            return rowData.V_BUDGETSD_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Detail",
                        field: "ACCDETAIL",
                        type: "string",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                    ]}
                    data={
                      budgetsdetailReducer.result
                        ? budgetsdetailReducer.result
                        : []
                    }
                    options={{
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },

                      showTitle: false,
                      searchFieldAlignment: "left",
                      exportButton: true,
                      toolbarButtonAlignment: "left",
                      exportAllData: true,
                      // actionsColumnIndex: -1,
                      pageSize: 5,
                      pageSizeOptions: [5, 10, 50, 100],
                      paging: true,
                    }}
                  />
                </Grid>
              </Grid>
              <br />
            </TabPanel>

            {/* Modal Investment */}
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={openinvestment}
              onClose={handleCloseModalInvestment}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openinvestment}>
                <div className={classes.paper}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={thLocale}>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        YEARID: yearId,
                        COUNTRYID: loginReducer.result.countryid,
                        COMPANYID: loginReducer.result.companyid,
                        BRANDID: brandId,
                        DEPARTID: deptId,
                        MEMID: loginReducer.result.perid,
                        SECID: loginReducer.result.secureid,
                        SID: budgetsReducer.sid,
                        PJYEARCODE: yearCode,
                        BTYPE: 1,
                        BNAME: "",
                        BLOCATION: "",
                        BSQM: "",
                        AREA: 1,
                        OPENDATE: "01/01/" + yearCode ,
                        CLOSEDATE: "12/31/" + yearCode,
                        REMARK: yearLock >= 1 ? "New Project for PR" : "",
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                       debugger
                        setTimeout(() => {
                          dispatch(
                            insertprojectActions.insertProjectById(values)
                          );
                        }, 1000);

                        setTimeout(() => {
                          dispatch(
                            getprojectActions.getProject(budgetsReducer.sid)
                          );
                        }, 1500);

                        handleCloseModalInvestment();
                      }}
                    >
                      {(props) => showModalinvest(props)}
                    </Formik>
                  </MuiPickersUtilsProvider>
                </div>
              </Fade>
            </Modal>

            {/* Modal InvestmentEdit */}
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={openinvestmentedit}
              onClose={handleCloseModalInvestmentEdit}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openinvestmentedit}>
                <div className={classes.paper}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Formik
                      enableReinitialize
                      initialValues={editData}
                      onSubmit={(values, { setSubmitting }) => {
                        const { BUDGETP_ID } = values;
                        dispatch(
                          insertprojectActions.updateProjectById(
                            BUDGETP_ID,
                            values
                          )
                        );
                        setTimeout(() => {
                          dispatch(
                            getprojectActions.getProject(budgetsReducer.sid)
                          );
                        }, 1000);

                        handleCloseModalInvestmentEdit();
                      }}
                    >
                      {(props) => showModalinvestEdit(props)}
                    </Formik>
                  </MuiPickersUtilsProvider>
                </div>
              </Fade>
            </Modal>
            {/* Modal Approve */}
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={openModalApprove}
              onClose={handleCloseModalApprove}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
              disableBackdropClick
            >
              <Fade in={openModalApprove}>
                <div className={classes.paper}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Formik
                      enableReinitialize
                      initialValues={editData}
                      onSubmit={(values, { setSubmitting }) => {
                        // ------------------------
                        // ------------------------
                        // edit Project master
                        // ------------------------
                        // ------------------------
                        // dispatch add data call action
                        // const { BUDGETP_ID } = values;
                        // dispatch(
                        //   insertprojectActions.updateProjectById(BUDGETP_ID, values)
                        // );
                        // handleCloseModalInvestmentEdit();
                        // dispatch(getprojectActions.getProject(budgetsReducer.sid));
                        //------------------------------
                        //------------------------------
                      }}
                    >
                      {(props) => showModalApprove(props)}
                    </Formik>
                  </MuiPickersUtilsProvider>
                </div>
              </Fade>
            </Modal>
            <CustomDialog
              title="Confirmation dialog"
              message="Confirm to delete Project ?"
              open={openDlgconfirm}
              onClose={handleConfirmDlg}
              disableBackdropClick
            />
            <CustomDialog
              title="Confirmation dialog"
              message="Confirm to Update budget?"
              open={openDlgconfirmBudget}
              onClose={handleConfirmDlgBudget}
              disableBackdropClick
            />
            <PopupDialog
              title="Information Message"
              message={
                getfilesReducer.isFetching ? (
                  <Alert severity="info">Loading ...</Alert>
                ) : getfilesReducer.isError ? (
                  <Alert severity="error">Cannot Send Mail.</Alert>
                ) : (
                  <Alert severity="success">
                    Send E-mail to {loginReducer.result.email} Completed.
                  </Alert>
                )
              }
              disabledBtn={getfilesReducer.isFetching ? true : false}
              // disabledBtn={true}
              open={openPopupDlg}
              onClose={handlePopupDlg}
            />
            <PopupDialog
              title="Information Message"
              message={<Alert severity="success">Submission successful.</Alert>}
              // disabledBtn={getfilesReducer.isFetching ? true : false}
              open={openPopupDlgSucc}
              onClose={handlePopupDlgSucc}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
